import userService from '../services/userService'
import cookieHelper from '../services/cookieHelper'
import { getEnvVar } from '@/assets/js/helpers'

const user = JSON.parse(localStorage.getItem('user'))
const debugUserId = userService.debugUserId

const state = {
  isAuthorized: !!(user && user.id),
  user: user || {},
  userUpdated: false
}

const mutations = {
  saveUser (state, data) {
    state.isAuthorized = !!data.isAuthorized
    state.user = state.isAuthorized ? (data.user || {}) : {}
    localStorage.setItem('user', JSON.stringify(state.user))
    state.userUpdated = true
  }
}

const getters = {}

const actions = {
  getUser ({ commit }) {
    if (debugUserId) {
      commit('saveUser', {
        isAuthorized: true,
        user: {
          id: debugUserId,
          fullName: 'N N'
        }
      })
      return
    }
    userService.getUser()
      .then((response) => {
        commit('saveUser', response.data)
      })
      .catch(() => {
        commit('saveUser', {
          isAuthorized: false,
          user: null
        })
      })
  },
  logout () {
    cookieHelper.deleteCookie('AspNet.RussiaRunning.20191107')
    localStorage.removeItem('user')
    window.location.href = getEnvVar('VUE_APP_RR_URL') + 'auth/logoff?returnUrl=' + encodeURIComponent(window.location.href)
  },
  setOnboardingShown () {
    userService.onboardingShown()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
